@if (payments) {
  <div class="tabs-area icon-tab payments-details-{{ brand }}">
    <nav class="pb-3">
      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
        <a
          class="nav-item nav-link left-border-tab {{ paymentsListTab }}"
          (click)="setActiveTab('liste', false)"
          id="nav-list-tab"
          data-toggle="tab"
          href="#nav-list"
          role="tab"
          aria-controls="nav-list"
        aria-selected="true">MES PAIEMENTS</a>
        @if (brand === 'lacarte') {
          <a
            class="nav-item nav-link left-border-tab right-border-tab {{ walletListTab }}"
            (click)="setActiveTab('walletList', false)"
            id="nav-wallet-list-tab"
            data-toggle="tab"
            href="#nav-wallet-list"
            role="tab"
            aria-controls="nav-wallet-list"
          aria-selected="false">Wallet</a>
        }
        <a
          class="nav-item nav-link left-border-tab right-border-tab {{ paymentManagementTab }}"
          (click)="setActiveTab('gestion', false)"
          id="nav-management-tab"
          data-toggle="tab"
          href="#nav-management"
          role="tab"
          aria-controls="nav-management"
        aria-selected="false">GESTION DE MES PAIEMENTS</a>
        @if (notificationsPaginator?.data?.length > 0) {
          <a
            class="nav-item nav-link right-border-tab {{ notificationsTab }}"
            (click)="setActiveTab('notifications', false)"
            id="nav-notifications-tab"
            data-toggle="tab"
            href="#nav-notifications"
            role="tab"
            aria-controls="nav-notifications"
            aria-selected="false">NOTIFICATIONS
            <app-notif-bell [notificationsNumber]="notificationsPaginator?.totalUnread"></app-notif-bell>
          </a>
        }
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade show {{ paymentsListTab }}" id="nav-list" role="tabpanel" aria-labelledby="nav-list-tab">
        <h2>Mes paiements :</h2>
        <div>
          <div class="no-overflow">
            <div id="payment-situation" class="d-flex align-content-start flex-wrap pt-2">
              <div class="w-100">
                <div class="bold-label-text">
                  <strong>Situation au {{ payments.date }} : </strong> <span [innerHTML]="situationText(payments.total)"></span>
                </div>
                @if (payments.total > 0) {
                  <div>Pour payer, rendez-vous dans <a href="/factures/gestion" class="bill-management">Gestion de Mes factures</a></div>
                }
              </div>
              <br>
                @if (brand === 'prixtel' && (payments.total > 0 || supportUser)) {
                  <div class="w-100">
                    <button type="button" class="cta_btn level_2" (click)="displaySchedule($event)">Afficher l'échéancier<span></span></button>
                    @if (!hideSchedule && paymentsSchedule.length > 0) {
                      <table class="table table-striped border-top-0">
                        <thead>
                          <tr>
                            <th class="text-center">Période</th>
                            <th class="text-center">Date de facture</th>
                            <th class="text-center">Date de prélèvement</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (paymentSchedule of paymentsSchedule; track paymentSchedule) {
                            <tr>
                              <td>{{ paymentSchedule.period }}</td>
                              <td>{{ paymentSchedule.billDate }}</td>
                              <td>{{ paymentSchedule.levyDate }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
          <div [className]="'hr-'+environment.data.brand"></div>
          @if (payments.data.length > 0) {
            <h2 class="bold-text mb-4">Historique de mes paiements :</h2>
          }
          @for (payment of payments.data; track payment) {
            <table class="table table-striped border-top-0 payment-history">
              @if (payments) {
                <tr>
                  <td class="force-width"><strong>Date :</strong> {{ payment.date }}</td>
                  <td><strong>Montant :</strong> {{ decimalComma(payment.amount) }}€</td>
                  <td align="right" width="135">
                    <strong>État :</strong> <app-dot [payment]="payment" [className]="'payment_dot_status'"></app-dot>
                  </td>
                </tr>
              }
              @if (payment.billingOutId) {
                <tr>
                  <td colspan="3"><strong>Référence du prélèvement :</strong> {{ payment.billingOutId }} {{ payment.plv_type }}</td>
                </tr>
              }
              @if (!payment.real_extra.toLowerCase().includes('avoir')) {
                <tr>
                  <td>
                    <strong>Type :</strong> {{ payment.real_extra.replace('saisie: ', '') }}
                  </td>
                  <td>
                    @if (payment.extra && payment.real_extra != payment.extra) {
                      <div>
                        <strong>Motif:</strong> {{ payment.extra }} @if (payment.paymentId && payment.paymentId > 0) {
                        <span> (Transaction N° {{ payment.paymentId }}) </span>
                      }
                    </div>
                  }
                  @if (!payment.extra || payment.real_extra == payment.extra && payment.paymentId && payment.paymentId > 0) {
                    <span>
                      <strong>Transaction N°</strong> {{ payment.paymentId }}
                    </span>
                  }
                </td>
                <td>&nbsp;</td>
              </tr>
            }
            <!-- avoir -->
            @if (payment.file && brand == 'prixtel') {
              <tr>
                <td><strong>Type :</strong> {{ payment.extra }} @if (payment.paymentId && payment.paymentId > 0) {
                <span>(Transaction N° {{ payment.paymentId }})</span>
              }</td>
              <td colspan="2"><span (click)="getCreditFile(payment)" class="credit-pdf">Télécharger votre avoir</span></td>
            </tr>
          }
          @if (payment.real_extra.toLowerCase().includes('avoir')) {
            <tr>
              <td>
                  <strong>Type :</strong> Avoir<br/>
                  <strong style="display: inline-block">Motif :</strong> <div [innerHTML]="payment.extra"></div>
                  @if (payment.paymentId && payment.paymentId > 0) {
                    <span>(Transaction N° {{ payment.paymentId }})</span>
                  }
            </td>
            <td><span (click)="getInvoiceCredit(payment)" class="credit-pdf">Télécharger votre avoir</span></td>
          </tr>
        }
        <!-- fin avoir -->
      </table>
    }
    @if (payments && payments?.totalItems > 5) {
      <div>
        <app-paginator></app-paginator>
      </div>
    }
    @if (payments.data.length === 0) {
      <div class="mt-4 mb-4">Aucun paiement n'a été effectué sur ce compte.</div>
    }
    @if (payments.data.length === 0) {
      <div [className]="'hr-'+environment.data.brand"></div>
    }
    <div class="payment-status">
      <strong class="bold-text">Explication des couleurs :</strong>
      <p><app-dot [dynamicClass]="'green'"></app-dot>Il s'agit d'un paiement validé, d'un avoir ou d'un gain de parrainage.</p>
      <p><app-dot [dynamicClass]="'red'"></app-dot>Il s'agit d'un paiement rejeté, annulé ou bien remboursé.</p>
    </div>
  </div>
  @if (brand === 'lacarte') {
    <div class="tab-pane fade show {{ walletListTab }}" id="nav-wallet-list" role="tabpanel" aria-labelledby="nav-wallet-list-tab">
      @if (wallet) {
        <div>
          @if (wallet.data.length > 0) {
            <h2 class="bold-text mb-4">Historique de mes versements :</h2>
          }
          @for (walletEntry of wallet.data; track walletEntry) {
            <table class="table table-striped border-top-0 payment-history">
              @if (wallet) {
                <tr>
                  <td class="force-width"><strong>Date :</strong> {{ walletEntry.insertedAt }}</td>
                  <td colspan="2"><strong>Montant :</strong> {{ decimalComma(walletEntry.amountTtc) }}€</td>
                </tr>
              }
              <tr>
                <td>
                  <strong>Ligne:</strong> {{ walletEntry.msisdn }}
                </td>
                <td>
                  <strong>Motif:</strong> Recharge Wallet
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Payment Method:</strong> {{ walletEntry.paymentMethod.toUpperCase() }}
                </td>
                <td>&nbsp;</td>
              </tr>
            </table>
          }
          @if (wallet?.totalItems > 5) {
            <div>
              <app-paginator></app-paginator>
            </div>
          }
        </div>
      }
    </div>
  }
  <div class="tab-pane fade show {{ paymentManagementTab }}" id="nav-management" role="tabpanel" aria-labelledby="nav-management-tab">
    @if (paymentManagementTab) {
      <app-payments-management [procedureInParam]="procedureInParam"></app-payments-management>
    }
  </div>
  @if (notificationsPaginator?.data?.length > 0 && notificationsTab == 'active') {
    <div class="tab-pane fade show {{ notificationsTab }}" id="nav-notifications" role="tabpanel" aria-labelledby="nav-notifications-tab">
      <app-notifications [notificationsPaginator]="notificationsPaginator" [type]="'payment'"></app-notifications>
    </div>
  }
</div>
</div>
}
<app-frequently-questions [faq]="faqPageCode"></app-frequently-questions>
